const RAW_HIERARCHY_CSV = `
Design,,,,,
Design,BIM/CAD,,,,,
Design,BIM/CAD,Standards,,,,
Design,Utilities,,,,,
Design,Utilities,Gas,,,,
Design,Utilities,Gas,Natural Gas Supply,,,
Design,Utilities,Gas,Propane Storage & Distribution,,,
Design,Utilities,Gas,Gas Leak Detection & Safety Systems,,,
Design,Utilities,Refuse and Waste,,,,
Design,Utilities,Refuse and Waste,General Waste Collection,,,
Design,Utilities,Refuse and Waste,Recycling Programs,,,
Design,Utilities,Refuse and Waste,Composting and Organic Waste,,,
Design,Utilities,Refuse and Waste,Hazardous Waste Disposal,,,
Design,Utilities,District Energy & Heating,,,,
Design,Utilities,District Energy & Heating,District Heating and Cooling,,,
Design,Utilities,District Energy & Heating,Geothermal Systems,,,
Design,Utilities,District Energy & Heating,CHP Combined Heat & Power,,,
Design,Utilities,District Energy & Heating,Heat Recovery Systems,,,
Design,Utilities,Alt & Renewable Energy,,,,
Design,Utilities,Alt & Renewable Energy,Solar Energy,,,
Design,Utilities,Alt & Renewable Energy,Wind Power,,,
Design,Utilities,Alt & Renewable Energy,Battery Storage Systems,,,
Design,Utilities,Alt & Renewable Energy,EV Charging Infrastructure,,,
Design,Utilities,Water,,,,
Design,Utilities,Water,Potable Water,,,
Design,Utilities,Water,Irrigation Systems,,,
Design,Utilities,Water,Fire Protection Water,,,
Design,Utilities,Water,Water Storage & Treatment,,,
Design,Utilities,Electrical,,,,
Design,Utilities,Electrical,Power Distribution,,,
Design,Utilities,Electrical,Lighting Systems,,,
Design,Utilities,Electrical,Metering & Monitoring,,,
Design,Utilities,Electrical,Backup Power Systems,,,
Design,Utilities,Electrical,Main Power Supply,,,
Design,Utilities,Comms,,,,
Design,Utilities,Comms,Security Systems,,,
Design,Utilities,Comms,Smart City Infrastructure,,,
Design,Utilities,Comms,Cable & Satellite TV,,,
Design,Utilities,Comms,Telephone Systems,,,
Design,Utilities,Comms,Internet & Fiber Optics,,,
Design,Utilities,Sewer and Drainage,,,,
Design,Utilities,Sewer and Drainage,Sanitary Sewer,,,
Design,Utilities,Sewer and Drainage,Stormwater Management,,,
Design,Utilities,Sewer and Drainage,Greywater Recycling,,,
Design,Utilities,Sewer and Drainage,Septic Systems,,,
Design,Engineering,,,,,
Design,Engineering,Civil,,,,
Design,Engineering,Civil,Surveying,,,
Design,Engineering,Civil,Surveying,Topography,,
Design,Engineering,Civil,Surveying,Utilities,,
Design,Engineering,Civil,Surveying,Construction,,
Design,Engineering,Civil,Surveying,Land and Legal,,
Design,Engineering,Civil,Surveying,Mining,,
Design,Engineering,Civil,Traffic,,,
Design,Engineering,Civil,Traffic,Vehicular,,
Design,Engineering,Civil,Traffic,Vehicular,Air,
Design,Engineering,Civil,Traffic,Vehicular,Marine ,
Design,Engineering,Civil,Traffic,Vehicular,Automobile,
Design,Engineering,Civil,Traffic,Vehicular,Automobile,Public
Design,Engineering,Civil,Traffic,Vehicular,Automobile,Private
Design,Engineering,Civil,Traffic,Pedestrian,,
Design,Engineering,Civil,Traffic,Railway,,
Design,Engineering,Civil,Traffic,Railway,Public,
Design,Engineering,Civil,Traffic,Railway,Private,
Design,Engineering,Civil,Structural,,,
Design,Engineering,Civil,Structural,Load Calculations,,
Design,Engineering,Civil,Structural,Connections,,
Design,Engineering,Civil,Structural,Member Sizing,,
Design,Engineering,Civil,Infrastructure,,,
Design,Engineering,Civil,Infrastructure,Roads,,
Design,Engineering,Civil,Infrastructure,Dams,,
Design,Engineering,Civil,Infrastructure,Bridges,,
Design,Engineering,Civil,Geotechnical,,,
Design,Engineering,Civil,Geotechnical,Soils and Ground Water,,
Design,Engineering,Civil,Geotechnical,Excavation,,
Design,Engineering,Civil,Environmental,,,
Design,Engineering,MEP,,,,
Design,Engineering,MEP,Fire Protection,,,
Design,Engineering,MEP,Fire Protection,Mechanical,,
Design,Engineering,MEP,Fire Protection,Wet ,,
Design,Engineering,MEP,Fire Protection,Dry,,
Design,Engineering,MEP,Electrical,,,
Design,Engineering,MEP,Electrical,Lighting,,
Design,Engineering,MEP,Electrical,Comms,,
Design,Engineering,MEP,Electrical,Security,,
Design,Engineering,MEP,Electrical,Power & Distribution,,
Design,Engineering,MEP,Mechanical,,,
Design,Engineering,MEP,Mechanical,Cooling,,
Design,Engineering,MEP,Mechanical,Heating,,
Design,Engineering,MEP,Mechanical,Ventilation,,
Design,Engineering,MEP,Plumbing,,,
Design,Engineering,MEP,Plumbing,Venting,,
Design,Engineering,MEP,Plumbing,Supply,,
Design,Engineering,MEP,Plumbing,Storm,,
Design,Engineering,MEP,Plumbing,Sanitary,,
Design,Zoning & Approvals,,,,,
Design,Zoning & Approvals,Lending,,,,
Design,Zoning & Approvals,Lending,Rebates,,,
Design,Zoning & Approvals,Lending,CMHC,,,
Design,Zoning & Approvals,Lending,Energy Assessment,,,
Design,Zoning & Approvals,Heritage,,,,
Design,Zoning & Approvals,Heritage,Heritage Approvals,,,
Design,Zoning & Approvals,Heritage,Reinstatement Plan,,,
Design,Zoning & Approvals,Planning,,,,
Design,Zoning & Approvals,Planning,Rezoning,,,
Design,Zoning & Approvals,Planning,Development Approval,,,
Design,Zoning & Approvals,Planning,Site Plan Approval,,,
Design,Zoning & Approvals,Planning,Minor Variance,,,
Design,Zoning & Approvals,Planning,LUB Ammendments,,,
Design,Zoning & Approvals,Building,,,,
Design,Zoning & Approvals,Building,Construction Management Plan,,,
Design,Zoning & Approvals,Building,Blasting,,,
Design,Zoning & Approvals,Building,Grade Alteration,,,
Design,Zoning & Approvals,Building,Demolition,,,
Design,Zoning & Approvals,Building,Occupancy,,,
Design,Zoning & Approvals,Building,Building Permits,,,
Design,Zoning & Approvals,Building,Street Closure,,,
Design,Zoning & Approvals,Building,ROW Permit,,,
Design,Zoning & Approvals,Utilities,,,,
Design,Zoning & Approvals,Utilities,Safety,,,
Design,Zoning & Approvals,Utilities,Comms,,,
Design,Zoning & Approvals,Utilities,Water & Sewer,,,
Design,Zoning & Approvals,Utilities,Electrical,,,
Design,Zoning & Approvals,Utilities,Gas,,,
Design,Zoning & Approvals,Environmental,,,,
Design,Zoning & Approvals,Environmental,Site Contamination,,,
Design,Zoning & Approvals,Environmental,Archaeological,,,
Design,Zoning & Approvals,Environmental,Tree Inventory,,,
Design,Zoning & Approvals,Environmental,Environmental Assessment,,,
Design,Zoning & Approvals,Environmental,Shoreline Restoration,,,
Design,Zoning & Approvals,Environmental,Hydrogeological,,,
Design,Zoning & Approvals,Submission Requirements,,,,
Design,Zoning & Approvals,Submission Requirements,Drawings,,,
Design,Zoning & Approvals,Submission Requirements,Forms,,,
Design,Zoning & Approvals,Submission Requirements,Fees,,,
Design,Arch/Interior Design,,,,,
Design,Arch/Interior Design,Interiors,,,,
Design,Arch/Interior Design,Interiors,Furniture,,,
Design,Arch/Interior Design,Interiors,Lighting,,,
Design,Arch/Interior Design,Interiors,Materials,,,
Design,Arch/Interior Design,Interiors,Millwork,,,
Design,Arch/Interior Design,Architecture,,,,
Design,Arch/Interior Design,Architecture,Materials,,,
Design,Arch/Interior Design,Architecture,Building Science,,,
Design,Arch/Interior Design,Architecture,Built Form,,,
Design,Arch/Interior Design,Architecture,Accessibility,,,
Design,Arch/Interior Design,Architecture,Building Code,,,
Design,Arch/Interior Design,Architecture,Sustainability,,,
Design,Arch/Interior Design,Landscape,,,,
Design,Arch/Interior Design,Landscape,Softscape,,,
Design,Arch/Interior Design,Landscape,Hardscape,,,
Design,Arch/Interior Design,Landscape,Site Circulation,,,
Design,Arch/Interior Design,Landscape,Sustainability,,,
Design,Arch/Interior Design,Landscape,Lighting & Safety,,,
Design,Arch/Interior Design,Landscape,Recreation & Function Spaces,,,
Design,Arch/Interior Design,Heritage,,,,
Design,Arch/Interior Design,Heritage,Identification,,,
Design,Arch/Interior Design,Heritage,Designation,,,
Design,Arch/Interior Design,Heritage,Preservation,,,
Design,Arch/Interior Design,Heritage,Conservation,,,
Design,Arch/Interior Design,Heritage,Protection,,,
Design,Arch/Interior Design,Heritage,Rehabilitation,,,
Design,Ownership,,,,,
Design,Ownership,Requirements,,,,
Design,Ownership,Requirements,Vision & Goals,,,
Design,Ownership,Requirements,Use & Occupancy,,,
Design,Ownership,Requirements,Operational Needs,,,
Design,Ownership,Requirements,Future Flexibility,,,
Design,Ownership,Budget,,,,
Design,Ownership,Budget,Project Budget,,,
Design,Ownership,Budget,Financing & Funding Sources,,,
Design,Ownership,Budget,Cost Breakdown,,,
Design,Ownership,Budget,Value Engineering Strategies,,,
Design,Ownership,Schedule,,,,
Design,Ownership,Schedule,Project Timeline,,,
Design,Ownership,Schedule,Design Phases Timeline,,,
Design,Ownership,Schedule,Approval & Permitting Milestones,,,
Design,Ownership,Schedule,Procurement Schedule,,,
Design,Ownership,Schedule,Construction Schedule,,,
Design,Ownership,Marketing,,,,
Design,Ownership,Marketing,Public Relations & Branding ,,,
Design,Ownership,Marketing,Pre-Leasing & Sales Strategy,,,
Design,Ownership,Marketing,Stakeholder Communications,,,
Design,Ownership,Marketing,Investor & Lender Reporting,,,
Design,Ownership,Legal,,,,
Design,Ownership,Legal,Land Ownership,,,
Design,Ownership,Legal,Zoning,,,
Design,Ownership,Legal,Contracts & Agreements,,,
Design,Ownership,Legal,Risk Management & Insurance,,,
Design,Ownership,Legal,Environmental,,,
Design,Ownership,Legal,Safety Regulations,,,
Design,Ownership,Legal,IP Rights ,,,
Design,Ownership,Commissioning,,,,
Design,Ownership,Commissioning,Owners Project Requirements,,,
Design,Ownership,Commissioning,Design Review & Compliance,,,
Design,Ownership,Commissioning,Building Systems,,,
Design,Ownership,Commissioning,Performance Criteria,,,
Design,Ownership,Commissioning,Lifecycle Maintenance & Planning,,,
Design,Ownership,Commissioning,Testing & Validation Plan,,,
Design,Specifications,,,,,
Design,Specifications,Installation,,,,
Design,Specifications,Installation,Methods & Procedures,,,
Design,Specifications,Installation,Site Preparation,,,
Design,Specifications,Installation,Environmental Conditions,,,
Design,Specifications,Installation,Sequencing & Coordination,,,
Design,Specifications,Warranty,,,,
Design,Specifications,Warranty,Manufacturer,,,
Design,Specifications,Warranty,Workmanship,,,
Design,Specifications,Warranty,Performance Guarantees,,,
Design,Specifications,Warranty,Maintanance Requirements,,,
Design,Specifications,Restrictions,,,,
Design,Specifications,Restrictions,Zoning & Lane Use,,,
Design,Specifications,Restrictions,Building Codes,,,
Design,Specifications,Restrictions,Fire Safety,,,
Design,Specifications,Restrictions,Site Constraints,,,
Design,Specifications,Restrictions,Material Usage Limits,,,
Design,Specifications,Standards,,,,
Design,Specifications,Standards,Industry Standards,,,
Design,Specifications,Standards,Sustainability Certifications,,,
Design,Specifications,Standards,Acoustic Performance,,,
Design,Specifications,Standards,Thermal Performance,,,
Design,Specifications,Standards,Testing & Compliance,,,
Design,Specifications,Materials,,,,
Design,Specifications,Materials,Primary Structural Materials,,,
Design,Specifications,Materials,Finishes & Aesthetics,,,
Design,Specifications,Materials,Performance-Based Materials,,,
Design,Specifications,Materials,Lifecycle & Maintenance,,,
Design,Specifications,Materials,Supply Chain Availability,,,
Build,,,,,,
Build,BIM/CAD/VDC,,,,,
Build,BIM/CAD/VDC,Standards,,,,
Build,BIM/CAD/VDC,Clash Reporting,,,,
Build,Construction Management,,,,,
Build,Construction Management,Quality Assurance,,,,
Build,Construction Management,Quality Assurance,Documentation & Reporting,,,
Build,Construction Management,Quality Assurance,Standards Compliance,,,
Build,Construction Management,Quality Assurance,Punch Lists & Deficiency Tracking,,,
Build,Construction Management,Quality Assurance,Materials & Workmanship,,,
Build,Construction Management,Budget & Cost Control,,,,
Build,Construction Management,Budget & Cost Control,Budget Tracking,,,
Build,Construction Management,Budget & Cost Control,Change Order Management,,,
Build,Construction Management,Budget & Cost Control,Cost-Control Strategies,,,
Build,Construction Management,Budget & Cost Control,Financial Reporting,,,
Build,Construction Management,Safety & Compliance,,,,
Build,Construction Management,Safety & Compliance,OSHA & Local Compliance,,,
Build,Construction Management,Safety & Compliance,Worker Training & Certifications,,,
Build,Construction Management,Safety & Compliance,Inspections & Reporting,,,
Build,Construction Management,Safety & Compliance,Insurance,,,
Build,Construction Management,Safety & Compliance,Site-Specific Safety Plans,,,
Build,Construction Management,Scheduling & Coordination,,,,
Build,Construction Management,Scheduling & Coordination,Master Schedule Development,,,
Build,Construction Management,Scheduling & Coordination,Master Schedule Development,Critical Path Method,,
Build,Construction Management,Scheduling & Coordination,Master Schedule Development,Gantt Charts,,
Build,Construction Management,Scheduling & Coordination,Look-Ahead Planning,,,
Build,Construction Management,Scheduling & Coordination,Delay Management,,,
Build,Construction Management,Scheduling & Coordination,Delay Management,Supply Chain Disruptions,,
Build,Construction Management,Scheduling & Coordination,Delay Management,Weather Impacts,,
Build,Construction Management,Scheduling & Coordination,Stakeolder Coordination,,,
Build,Construction Management,Scheduling & Coordination,Stakeolder Coordination,Architects,,
Build,Construction Management,Scheduling & Coordination,Stakeolder Coordination,Engineers,,
Build,Construction Management,Scheduling & Coordination,Stakeolder Coordination,Clients,,
Build,Construction Management,Scheduling & Coordination,Stakeolder Coordination,City Inspectors,,
Build,Construction Management,Resource Management,,,,
Build,Construction Management,Resource Management,Workforce Planning,,,
Build,Construction Management,Resource Management,Workforce Planning,In-House Staff,,
Build,Construction Management,Resource Management,Workforce Planning,Subcontractors,,
Build,Construction Management,Resource Management,Workforce Planning,External Consultants,,
Build,Construction Management,Resource Management,Equipment & Tool Allocation,,,
Build,Construction Management,Resource Management,Equipment & Tool Allocation,Owned vs Rented,,
Build,Construction Management,Resource Management,Equipment & Tool Allocation,Availability Tracking,,
Build,Construction Management,Resource Management,Material Logistics,,,
Build,Construction Management,Resource Management,Material Logistics,Delivery Scheduling,,
Build,Construction Management,Resource Management,Material Logistics,Storage,,
Build,Construction Management,Resource Management,Material Logistics,Handling,,
Build,Construction Management,Resource Management,Site Utilization Planning,,,
Build,Construction Management,Resource Management,Site Utilization Planning,Laydown Areas,,
Build,Construction Management,Resource Management,Site Utilization Planning,Temporary Facilities,,
Build,Construction Management,Project Closeout,,,,
Build,Construction Management,Project Closeout,Warranty & Maintenance Manuals,,,
Build,Construction Management,Project Closeout,Owner/Facility Manager Training,,,
Build,Construction Management,Project Closeout,As-Built Docs & BIM Handover,,,
Build,Construction Management,Project Closeout,Final Inspections,,,
Build,Procurement,,,,,
Build,Procurement,Selection Process,,,,
Build,Procurement,Selection Process,Materials,,,
Build,Procurement,Selection Process,Materials,Compliance,,
Build,Procurement,Selection Process,Materials,Availability,,
Build,Procurement,Selection Process,Materials,Suitability,,
Build,Procurement,Selection Process,Materials,Price,,
Build,Procurement,Selection Process,Equipment,,,
Build,Procurement,Selection Process,Equipment,Compliance,,
Build,Procurement,Selection Process,Equipment,Availability,,
Build,Procurement,Selection Process,Equipment,Suitability,,
Build,Procurement,Selection Process,Equipment,Price,,
Build,Procurement,Selection Process,Service,,,
Build,Procurement,Selection Process,Service,Compliance,,
Build,Procurement,Selection Process,Service,Availability,,
Build,Procurement,Selection Process,Service,Suitability,,
Build,Procurement,Selection Process,Service,Price,,
Build,Procurement,Bid Management,,,,
Build,Procurement,Bid Management,Research,,,
Build,Procurement,Bid Management,Preparation,,,
Build,Procurement,Bid Management,Submission,,,
Build,Procurement,Bid Management,Evaluation,,,
Build,Procurement,Bid Management,Award,,,
Build,Procurement,Execution,,,,
Build,Procurement,Execution,Negotiations,,,
Build,Procurement,Execution,Acceptance,,,
Build,Procurement,Execution,Purchase Orders,,,
Build,Procurement,Execution,Vendor Onboarding,,,
Build,Procurement,Execution,Delivery,,,
Build,Estimating,,,,,
Build,Estimating,Resources/Labor,,,,
Build,Estimating,Resources/Labor,Workforce Allocation,,,
Build,Estimating,Resources/Labor,Labor Rates & Productivity,,,
Build,Estimating,Resources/Labor,Overtime & Shift Work Costs,,,
Build,Estimating,Resources/Labor,Availability & Scheduling,,,
Build,Estimating,Quantity Take-off,,,,
Build,Estimating,Quantity Take-off,Architectural & Structural,,,
Build,Estimating,Quantity Take-off,MEP,,,
Build,Estimating,Quantity Take-off,Finishes & Speciality Items,,,
Build,Estimating,Quantity Take-off,Site & Civil Works,,,
Build,Estimating,Quantity Take-off,Waste Factors,,,
Build,Estimating,Quantity Take-off,Ordering Buffers,,,
Build,Estimating,Costs & Budgeting,,,,
Build,Estimating,Costs & Budgeting,Value Engineering,,,
Build,Estimating,Costs & Budgeting,Direct Costs,,,
Build,Estimating,Costs & Budgeting,Direct Costs,Materials,,
Build,Estimating,Costs & Budgeting,Direct Costs,Labor,,
Build,Estimating,Costs & Budgeting,Direct Costs,Equipment,,
Build,Estimating,Costs & Budgeting,Indirect Costs,,,
Build,Estimating,Costs & Budgeting,Indirect Costs,Overhead,,
Build,Estimating,Costs & Budgeting,Indirect Costs,Mobilization & Takedown,,
Build,Estimating,Costs & Budgeting,Indirect Costs,Contingencies,,
Build,Estimating,Tools/Equipment,,,,
Build,Estimating,Tools/Equipment,Small Tools,,,
Build,Estimating,Tools/Equipment,Consumables,,,
Build,Estimating,Tools/Equipment,Heavy Machinery,,,
Build,Estimating,Tools/Equipment,Rental vs Purchase Analysis,,,
Build,Estimating,Tools/Equipment,Maintenance & Depreciation Costs,,,
Build,Estimating,Change Orders,,,,
Build,Estimating,Change Orders,Price Escalation & Inflation,,,
Build,Estimating,Change Orders,Change Order Management,,,
Build,Estimating,Change Orders,Change Order Management,Scope Changes,,
Build,Estimating,Change Orders,Change Order Management,Client Requests,,
Build,Estimating,Change Orders,Alternative Cost Scenarios,,,
Build,Estimating,Change Orders,Alternative Cost Scenarios,Fast Tracking,,
Build,Estimating,Change Orders,Alternative Cost Scenarios,Material Substitutions,,
Build,Pre-fabrication,,,,,
Build,Pre-fabrication,Engineering,,,,
Build,Pre-fabrication,Engineering,Factory Design/ Conveyance,,,
Build,Pre-fabrication,Engineering,Mechanical,,,
Build,Pre-fabrication,Engineering,Fabrication/ Structural,,,
Build,Pre-fabrication,Modularization,,,,
Build,Pre-fabrication,Modularization,Exoskeleton,,,
Build,Pre-fabrication,Modularization,Finishing,,,
Build,Pre-fabrication,Modularization,Fasteners,,,
Build,Pre-fabrication,Modularization,Utilities,,,
Build,Pre-fabrication,Inspection,,,,
Build,Pre-fabrication,Inspection,Process & Safety,,,
Build,Pre-fabrication,Inspection,Manufacturing,,,
Build,Pre-fabrication,Inspection,Quality Control,,,
Build,Pre-fabrication,Shipping,,,,
Build,Pre-fabrication,Shipping,Schedule,,,
Build,Pre-fabrication,Shipping,Restrictions,,,
Build,Pre-fabrication,Shipping,Packaging & Preparation,,,
Build,Pre-fabrication,Assembly,,,,
Build,Pre-fabrication,Assembly,Tools & Maintenance,,,
Build,Pre-fabrication,Assembly,Training & SOP's,,,
Build,Pre-fabrication,Assembly,Code Formatting & Labelling,,,
Operate,,,,,,
Operate,CAFM/CAD/BIM,,,,,
Operate,CAFM/CAD/BIM,Standards,,,,
Operate,CAFM/CAD/BIM,CAFM Data,,,,
Operate,Portfolio Management,,,,,
Operate,Portfolio Management,Leasing,,,,
Operate,Portfolio Management,Leasing,Tenant Aquisition,,,
Operate,Portfolio Management,Leasing,Lease Agreements,,,
Operate,Portfolio Management,Leasing,Lease Admin,,,
Operate,Portfolio Management,Leasing,Tenant Relations,,,
Operate,Portfolio Management,Leasing,Rent Collection & Arrears,,,
Operate,Portfolio Management,Leasing,Vacancy Management,,,
Operate,Portfolio Management,Investments,,,,
Operate,Portfolio Management,Investments,Debt & Financing Strategies,,,
Operate,Portfolio Management,Investments,Dispositions & Acquistions,,,
Operate,Portfolio Management,Investments,ROI Analysis,,,
Operate,Portfolio Management,Investments,Asset Diversification,,,
Operate,Portfolio Management,Investments,CapEx Planning,,,
Operate,Portfolio Management,Investments,Portfolio Valuation,,,
Operate,Portfolio Management,Asset Strategy,,,,
Operate,Portfolio Management,Asset Strategy,Exit Strategies,,,
Operate,Portfolio Management,Asset Strategy,Risk Management,,,
Operate,Portfolio Management,Asset Strategy,Market Trends & Forecasting,,,
Operate,Building Systems,,,,,
Operate,Building Systems,MEP,,,,
Operate,Building Systems,MEP,Electrical Distribution,,,
Operate,Building Systems,MEP,Plumbing & Water Supply,,,
Operate,Building Systems,MEP,HVAC Systems,,,
Operate,Building Systems,Building Automation,,,,
Operate,Building Systems,Building Automation,Building Automation Systems (BAS),,,
Operate,Building Systems,Building Automation,Suite Management Systems,,,
Operate,Building Systems,Building Automation,IoT & Remote Monitoring,,,
Operate,Building Systems,Security & Safety,,,,
Operate,Building Systems,Security & Safety,Access Control & Surveillance,,,
Operate,Building Systems,Security & Safety,Fire Safety & Life Safety Systems,,,
Operate,Building Systems,Security & Safety,Cybersecurity for Smart Systems,,,
Operate,Building Systems,Monitoring & Management,,,,
Operate,Building Systems,Monitoring & Management,Energy Management Systems,,,
Operate,Building Systems,Monitoring & Management,Water & Waste Management Systems,,,
Operate,Building Systems,Monitoring & Management,Grid Integration & Renewable Energy,,,
Operate,Building Systems,Charging & Transportation Infrastructure,,,,
Operate,Building Systems,Charging & Transportation Infrastructure,EV Charging Networks,,,
Operate,Building Systems,Charging & Transportation Infrastructure,Elevators & Vertical Transport,,,
Operate,Building Systems,Charging & Transportation Infrastructure,Parking & Smart Traffic Systems,,,
Operate,Facilities Management,,,,,
Operate,Facilities Management,Building Maintenance & Repairs,,,,
Operate,Facilities Management,Building Maintenance & Repairs,Preventative Maintenance,,,
Operate,Facilities Management,Building Maintenance & Repairs,Emergency Repairs,,,
Operate,Facilities Management,Building Maintenance & Repairs,Contractor & Vendor Management,,,
Operate,Facilities Management,Facilities Services,,,,
Operate,Facilities Management,Facilities Services,Janitorial & Cleaning,,,
Operate,Facilities Management,Facilities Services,Groundskeeping & Landscaping,,,
Operate,Facilities Management,Facilities Services,Waste Management,,,
Operate,Facilities Management,"Health, Safety & Compliance",,,,
Operate,Facilities Management,"Health, Safety & Compliance",Fire Safety & Life Safety Systems,,,
Operate,Facilities Management,"Health, Safety & Compliance",Building Codes & Accessibility,,,
Operate,Facilities Management,"Health, Safety & Compliance",OSHA & Regulatory Compliance,,,
Operate,Facilities Management,Sustainability & Energy Management,,,,
Operate,Facilities Management,Sustainability & Energy Management,Energy Efficiency Programs,,,
Operate,Facilities Management,Sustainability & Energy Management,Water & Waste Management,,,
Operate,Facilities Management,Sustainability & Energy Management,LEED & Green Building Initiatives,,,
Operate,Facilities Management,Tenant & Occupany Services,,,,
Operate,Facilities Management,Tenant & Occupany Services,Security & Access Control,,,
Operate,Facilities Management,Tenant & Occupany Services,Parking & Transportation Services,,,
Operate,Facilities Management,Tenant & Occupany Services,Community & Shared Spaces Management,,,
Operate,Facilities Management,Asset Management,,,,
Operate,Facilities Management,Asset Management,Equipment & Maintenance Tracking,,,
Operate,Facilities Management,Asset Management,Furniture and Non-Fixed Millwork,,,
Operate,Facilities Management,Asset Management,IT & Communications Hardware,,,
Operate,Facilities Management,Asset Management,Digital Twinning,,,
`.trim();


function parseCsvHierarchy(csv) {
  const rows = [];

  for (const rawLine of csv.split(/\r?\n/)) {
    const line = rawLine.trim();
    if (!line) continue;

    const values = [];
    let current = '';
    let inQuotes = false;

    for (let i = 0; i < line.length; i++) {
      const ch = line[i];

      if (ch === '"') {
        inQuotes = !inQuotes;
      } else if (ch === ',' && !inQuotes) {
        values.push(current.trim());
        current = '';
      } else {
        current += ch;
      }
    }
    values.push(current.trim());

    while (values.length && !values[values.length - 1]) {
      values.pop();
    }

    if (values.length) {
      rows.push(values);
    }
  }

  return rows;
}

export const RAW_HIERARCHY = parseCsvHierarchy(RAW_HIERARCHY_CSV);

function buildHierarchy(rows) {
  const tree = {};

  for (const row of rows) {
    const levels = row.map((v) => (v || '').trim()).filter(Boolean);
    if (!levels.length) continue;

    let current = tree;
    for (const label of levels) {
      if (!current[label]) {
        current[label] = { children: {} };
      }
      current = current[label].children;
    }
  }

  return tree;
}

export const HIERARCHY_TREE = buildHierarchy(RAW_HIERARCHY);

export function getIndustryOptions(phaseLabel) {
  if (!phaseLabel) return [];
  return Object.keys(HIERARCHY_TREE[phaseLabel]?.children || {}).sort();
}

export function getCategoryOptions(phaseLabel, industry) {
  if (!phaseLabel || !industry) return [];
  return Object.keys(
    HIERARCHY_TREE[phaseLabel]?.children?.[industry]?.children || {}
  ).sort();
}

export function getLevel4Options(phaseLabel, industry, category) {
  if (!phaseLabel || !industry || !category) return [];
  return Object.keys(
    HIERARCHY_TREE[phaseLabel]?.children?.[industry]?.children?.[category]
      ?.children || {}
  ).sort();
}

export function getLevel5Options(phaseLabel, industry, category, level4) {
  if (!phaseLabel || !industry || !category || !level4) return [];
  return Object.keys(
    HIERARCHY_TREE[phaseLabel]?.children?.[industry]?.children?.[category]
      ?.children?.[level4]?.children || {}
  ).sort();
}

export function getLevel6Options(
  phaseLabel,
  industry,
  category,
  level4,
  level5
) {
  if (!phaseLabel || !industry || !category || !level4 || !level5) return [];
  return Object.keys(
    HIERARCHY_TREE[phaseLabel]?.children?.[industry]?.children?.[category]
      ?.children?.[level4]?.children?.[level5]?.children || {}
  ).sort();
}
